import React, { useState } from "react";
import { formatNumberToCurrency, formatNumberToLocale } from "@utils/formatNumber";
import { formatWbsPath } from "@utils/formatWbsPath";
import { useProjectContext } from "@contexts/projects";

const getTotal = (arr, field) => {
  const total = arr.reduce((acc, item) => {
    const res = item[field] * item.labor_price;
    return acc + res;
  }, 0);
  return total;
}

// `formatNumberToLocale` só aceita número finito: o `.toFixed(2)` que havia nas linhas de
// Total Apropriado/Medido devolvia STRING, caía no fallback e toda linha exibia "0,00".
// O arredondamento já é do formatter.
const InnerAccordion = ({ item }) => {

  const [toggle, setToggle] = useState(false)
  // Lido aqui, e nao dentro do map: `formatWbsPath` chamava useContext por item.
  const { activeProject } = useProjectContext();

  const Item = ({ item }) => {
    return <div key={item.creditor_name} className="accordion-item margin-left-16">
      <div className="grid contracts-accordion-body" style={{ gridTemplateColumns: '1fr', gap: "16px" }}>
        <div className="flex gap-8 align-center">
          <button
            className={`accordion-toggle ${toggle ? "active" : ""}`}
            onClick={() => setToggle(!toggle)}
          />
          <div>
            <span className="accordion-label">Descrição</span>
            <span className="accordion-title">{item?.description}</span>
          </div>
        </div>
        <div className="grid columns-4-laptop">

          <div className="grid">
            <span className="accordion-label">Quantidade Apropriada</span>
            <span className="accordion-title">{item.apr_qty}</span>
          </div>
          <div className="grid">
            <span className="accordion-label">Total Apropriado (R$)</span>
            <span className="accordion-title">{formatNumberToLocale(item.apr_total)}</span>
          </div>

          <div className="grid">
            <span className="accordion-label">Quantidade Medida</span>
            <span className="accordion-title">{item.meas_qty}</span>
          </div>
          <div className="grid">
            <span className="accordion-label">Total Medido (R$)</span>
            <span className="accordion-title">{formatNumberToLocale(item.meas_total)}</span>
          </div>
        </div>
      </div>
      {toggle && item.items.map(i => {
        return <div key={i.id} className="accordion-item margin-left-16">

          <div className="grid contracts-accordion-body" style={{ gridTemplateColumns: '1fr', gap: "16px" }}>
            <div>
              <span className="accordion-label">Fornecedor - {i?.supplier_id}</span>
              <span className="accordion-title">{i?.supplier_name} - {formatWbsPath(i, activeProject)} </span>
            </div>
            <div className="grid columns-5-laptop">
              <div className="grid">
                <span className="accordion-label">Valor Unitário</span>
                <span className="accordion-title">{formatNumberToLocale(i?.labor_price)}</span>
              </div>
              <div className="grid">
                <span className="accordion-label">Quantidade Apropriada</span>
                <span className="accordion-title">{i?.quantity_apropriation}</span>
              </div>
              <div className="grid">
                <span className="accordion-label">Total Apropriado</span>
                <span className="accordion-title">{formatNumberToLocale(Number(i?.quantity_apropriation) * Number(i?.labor_price))}</span>
              </div>
              <div className="grid">
                <span className="accordion-label">Quantidade Medida</span>
                <span className="accordion-title">{i?.measured_quantity}</span>
              </div>
              <div className="grid">
                <span className="accordion-label">Total Medido</span>
                <span className="accordion-title">{formatNumberToLocale(Number(i?.measured_quantity) * Number(i?.labor_price))}</span>
              </div>
            </div>
          </div>
        </div>
      })}
    </div>
  }

  return <Item item={item} />
}

const ContractAccordion = ({ item }) => {

  const [toggle, setToggle] = useState(false)

  const Item = ({ item }) => {
    return <div key={item.creditor_name} className="accordion-item">
      <div className="contracts-accordion-body" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr" }}>
        <div className="flex gap-8 align-center">
          <button
            className={`accordion-toggle ${toggle ? "active" : ""}`}
            onClick={() => setToggle(!toggle)}
          />
          <div>
            <span className="accordion-label">Número</span>
            <span className="accordion-title">{item?.contract_number}</span>
          </div>
        </div>
        <div className="grid">
          <span className="accordion-label">Total apropriado</span>
          <span className="accordion-title">{item.apr_qty}</span>
        </div>
        <div className="grid">
          <span className="accordion-label">Total apropriado</span>
          <span className="accordion-title">{formatNumberToLocale(item?.apr_total)}</span>
        </div>
        <div className="grid">
          <span className="accordion-label">Total Medido</span>
          <span className="accordion-title">{item?.meas_qty}</span>
        </div>
        <div className="grid">
          <span className="accordion-label">Total Medido</span>
          <span className="accordion-title">{formatNumberToLocale(item?.meas_total)}</span>
        </div>
      </div>
      {toggle && item?.items?.map((i, idx) => <InnerAccordion key={i.total_labor_value} item={i} />)}
    </div>
  }

  return <Item item={item} />
}

export default ContractAccordion;